import React, { useRef } from 'react';
import classnames from 'classnames';
import { useEnteredView } from '@fiverr-private/hooks';
import { Button } from '@fiverr-private/button';
import pathfinder from '@fiverr-private/pathfinder';
import { triggerSignUp } from '@fiverr-private/identification_triggers';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import { translate } from '../../../shared/helpers';
import { sendBiankaImpression } from '../../../shared/biEvents';
import { EVENT_NAMES } from '../../../shared/biEvents/eventNames';
import { sendMixpanelEvent } from '../utils/mixpanel';
import { MIXPANEL_EVENTS } from '../utils/eventNames';

import * as styles from './styles.ve.css';

const CTA = () => {
  const container = useRef<HTMLDivElement>(null);
  const eventTrackingRef = useRef<HTMLDivElement>(null);

  useEnteredView(eventTrackingRef, {
    threshold: 1,
    onEntered: () => {
      sendBiankaImpression({
        eventName: EVENT_NAMES.BIANKA.EXPERTS_CAROUSEL_IS_SHOWN,
        componentName: 'cta_section',
        componentText: 'CTA Section',
      });
    },
  });

  const pathToJoin = pathfinder('join', undefined, { query: { source: 'hplo_get_started' } });

  const onSignUpButtonClick = async (event) => {
    event.preventDefault();

    sendMixpanelEvent({
      eventName: MIXPANEL_EVENTS.CLICKED_CTA_BUTTON,
      clickedElement: translate('v17.cta.cta'),
      elementSource: 'CTA Section',
    });

    await triggerSignUp({
      modalOptions: {
        triggerType: 'user_trigger',
        triggerId: 'hplo_get_started',
      },
    });
  };

  return (
    <Container ref={container}>
      <Stack direction="column" className={styles.wrapperStyles} alignItems="center">
        <Heading textAlign="center" color="white" className={styles.headingStyles} ref={eventTrackingRef}>
          {translate('v17.cta.heading')}
        </Heading>

        <Button
          href={pathToJoin}
          colorScheme="white"
          className={classnames('btn-signup', styles.buttonStyles)}
          onClick={onSignUpButtonClick}
        >
          {translate('v17.cta.cta')}
        </Button>
      </Stack>
    </Container>
  );
};

export default CTA;
